<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../app.config";
import CheckModal from "@/components/CheckModal";
import Capacitacion from "@/components/standard/Copass/Capacitacion";

/**
 * Form elements component
 */
export default {
  page: {
    title: "1.1.7 Capacitación del Copasst",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    Capacitacion,
    CheckModal,
  },
  data() {
    return {
      title: "1.1.7 Capacitación del Copasst",
      items: [{
        text: 'Estándares',
        href: '/forms/estandares',
      },
      {
        text: '1.1.6 Acta de conformación Copasst Vigía de salud',
        href: `/forms/estandares/${this.$store.getters["company/getCompany"].id}/acta-conformacion1.1.6`
      },
      {
        text: 'Capacitación del Copasst',
        active: true
      },
      ],

      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
    };
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div>
          <div class="card">
            <div class="card-body">
              <CheckModal>
                <p class="text-justify">
                  Una vez conformado el
                  <b>Comité Paritario de Seguridad y Salud en el Trabajo Copasst</b>, se
                  deberá planear la primera reunión y capacitarlos inicialmente en
                  funciones, roles y responsabilidades del comité.
                </p>
              </CheckModal>

              <div class="d-flex justify-content-center">
                <iframe width="734" height="413" src="https://www.youtube.com/embed/yaZGC0ER8cA" title="COPASST"
                  frameborder="0" allow="clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen>
                </iframe>
              </div>

              <Capacitacion />
            </div>
          </div>
        </div>

      </div>
    </div>
  </Layout>
</template>
